// extracted by mini-css-extract-plugin
export default {"preview":"CourseForm_preview__14i+U"};